<script setup>
import { computed } from "vue";

// eslint-disable-next-line no-undef
const props = defineProps({
  material: { type: Object, default: null },
  showIdentification: { type: Boolean, default: true },
});

const specLabels = {
  antivirus: "Antivirus", processor: "Procesador", memory: "Memoria",
  storage: "Almacenamiento", os: "Sistema Operativo", mac: "MAC",
  resolution: "Resolución", size: "Tamaño", connection: "Conexión",
  ports: "Puertos", speed: "Velocidad", firmware: "Firmware",
};
const typeLabel = computed(() => {
  const type = props.material?.type;
  return typeof type === "string" ? type : type?.name || "";
});
const fields = computed(() => {
  if (!props.material) return [];
  const material = props.material;
  const basic = [
    ...(props.showIdentification ? [
      { key: "type", label: "Tipo de material", value: typeLabel.value },
      { key: "serialTag", label: "Número de serie", value: material.serialTag },
    ] : []),
    { key: "model", label: "Modelo", value: material.model },
    { key: "brand", label: "Marca", value: material.brand },
    { key: "name", label: "Nombre", value: material.name },
    { key: "internalCode", label: "Código interno", value: material.internalCode },
  ];
  const specs = material.technicalSpecs;
  const technical = specs && !Array.isArray(specs) ? Object.entries(specs)
    .filter(([, value]) => value !== null && value !== undefined && value !== "")
    .map(([key, value]) => ({ key: "spec-" + key, label: specLabels[key] || key, value })) : [];
  return [...basic, ...technical];
});
</script>

<template>
  <div v-if="material" class="row material-info-fields">
    <div v-for="field in fields" :key="field.key" class="col-md-6 col-12 mt-3">
      <label class="w-100">{{ field.label }}</label>
      <el-input :model-value="field.value ?? ''" disabled class="w-100" />
    </div>
    <div v-if="material.notes" class="col-12 mt-3">
      <label class="w-100">Notas del material</label>
      <el-input :model-value="material.notes" type="textarea" :rows="4" disabled class="w-100" />
    </div>
    <div v-if="material.description" class="col-12 mt-3">
      <label class="w-100">Descripción del material</label>
      <el-input :model-value="material.description" type="textarea" :rows="4" disabled class="w-100" />
    </div>
  </div>
</template>

<style scoped>
.material-info-fields {
  margin-left: 0;
  margin-right: 0;
}

@media (max-width: 767.98px) {
  .material-info-fields > div {
    min-width: 0;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
